import React from 'react';
import './ActiveFilters.css';
import { useUser } from '../UserContext'; // Import the useUser hook
import { useSearchParams } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

const filterDisplayMap = {
  '300': 'My Cards',
  '100': 'Favorites',
  '9': 'Queue',
  '600': 'Sets',
  '400': 'Void',
  '101': 'Comments',
};

const ActiveFilters = ({  }) => {
  const { filters, setFilters } = useUser(); // Destructure setSelectedUser from the context
  const activeFilters = Object.keys(filters).filter(key => filters[key]);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleRemoveFilter = (filter) => {
    setSearchParams(prevParams => {
      prevParams.delete(filter);
      prevParams.delete('page');
      return prevParams;
    });
  };

  return (
    <div className="active-filters mb-3 user-select-none">
      {activeFilters.map(filter => (
		// <span className="filter-badge badge mx-1" key={filter} onClick={() => handleRemoveFilter(filter)}>{filter}: {filters[filter]} <span className="filter-badge-close"><FaTimes /></span></span>
    <span className="filter-badge badge mx-1" key={filter} onClick={() => handleRemoveFilter(filter)}>
  {filter}: {filterDisplayMap[filters[filter]] || filters[filter]} <span className="filter-badge-close"><FaTimes /></span>
</span>

      ))}
    </div>
  );
};

export default ActiveFilters;


